const organizations = {
    organization: 'องค์กร',
    page_title: 'องค์กร',
    title: 'องค์กร',
    subtitle: 'องค์กรมักถูกใช้ในแอป SaaS หรือแอปหลายผู้เช่าแบบเดียวกัน และแทนลูกค้าของคุณที่อาจเป็นทีม องค์กร หรือบริษัททั้งบริษัท องค์กรมักเป็นรากฐานสำคัญสำหรับการยืนยันตัวตนและการให้สิทธิ์แบบ B2B',
    organization_template: 'แม่แบบองค์กร',
    organization_id: 'รหัสองค์กร',
    members: 'สมาชิก',
    machine_to_machine: 'แอปพลิเคชันเครื่องสู่เครื่อง',
    create_organization: 'สร้างองค์กร',
    setup_organization: 'ตั้งค่าองค์กรของคุณ',
    organization_list_placeholder_title: 'องค์กร',
    organization_list_placeholder_text: 'องค์กรจะถูกใช้เป็นแนวปฏิบัติที่ดีในแอป SaaS หรือแอปหลายผู้เช่า คุณสามารถพัฒนาแอปที่อนุญาตให้ลูกค้าสร้างและจัดการองค์กร เชิญสมาชิก และกำหนดบทบาทได้',
    organization_name_placeholder: 'องค์กรของฉัน',
    organization_description_placeholder: 'รายละเอียดโดยย่อขององค์กร',
    organization_permission: 'สิทธิ์ขององค์กร',
    organization_permission_other: 'สิทธิ์ขององค์กร',
    create_permission_placeholder: 'ดูประวัติการนัดหมาย',
    organization_role: 'บทบาทขององค์กร',
    organization_role_other: 'บทบาทขององค์กร',
    organization_role_description: 'บทบาทขององค์กรคือการจัดกลุ่มสิทธิ์ที่สามารถมอบหมายให้ผู้ใช้ได้ โดยสิทธิ์จะต้องมาจากกลุ่มสิทธิ์ที่กำหนดไว้ล่วงหน้าขององค์กร',
    role: 'บทบาท',
    search_placeholder: 'ค้นหาด้วยชื่อองค์กรหรือรหัสองค์กร',
    search_role_placeholder: 'พิมพ์เพื่อค้นหาและเลือกบทบาท',
    empty_placeholder: '🤔 คุณยังไม่มีการตั้งค่า {{entity}} ใดๆ',
    organization_and_member: 'องค์กรและสมาชิก',
    organization_and_member_description: 'องค์กรคือกลุ่มของผู้ใช้ ที่สามารถแทนทีม ลูกค้าธุรกิจ และบริษัทคู่ค้า โดยแต่ละผู้ใช้จะเป็น "สมาชิก" เหล่านี้เป็นส่วนสำคัญสำหรับการจัดการแอปหลายผู้เช่าของคุณ',
    guide: {
        title: 'เริ่มต้นด้วยคู่มือ',
        subtitle: 'เริ่มตั้งค่าองค์กรของคุณด้วยคู่มือของเรา',
        introduction: {
            title: 'มาเรียนรู้ว่าองค์กรทำงานอย่างไรใน Logto',
            section_1: {
                title: 'องค์กรคือกลุ่มของผู้ใช้ (ไอดี)',
            },
            section_2: {
                title: 'แม่แบบองค์กรถูกออกแบบสำหรับการควบคุมการเข้าถึงในแอปหลายผู้เช่า',
                description: 'ในแอป SaaS หลายผู้เช่า หลายองค์กรอาจใช้แม่แบบการควบคุมการเข้าถึงเดียวกัน ซึ่งรวมถึงสิทธิ์และบทบาท ใน Logto เราเรียกว่า "แม่แบบองค์กร"',
                permission_description: 'สิทธิ์ขององค์กรหมายถึงการอนุญาตให้เข้าถึงทรัพยากรในบริบทขององค์กร',
                role_description_deprecated: 'บทบาทขององค์กรคือการจัดกลุ่มสิทธิ์ขององค์กรที่มอบหมายให้สมาชิกได้',
                role_description: 'บทบาทขององค์กรคือการจัดกลุ่มสิทธิ์ขององค์กรหรือสิทธิ์ API ที่มอบหมายให้สมาชิกได้',
            },
            section_3: {
                title: 'สามารถกำหนดสิทธิ์ API ให้กับบทบาทองค์กรได้หรือไม่?',
                description: 'ได้ คุณสามารถกำหนดสิทธิ์ API ให้กับบทบาทองค์กร Logto ให้อิสระแก่คุณในการจัดการบทบาทองค์กร รวมสิทธิ์ขององค์กรและสิทธิ์ API ภายในบทบาทเดียวกันได้',
            },
            section_4: {
                title: 'โต้ตอบกับภาพประกอบเพื่อดูการเชื่อมโยงของทุกส่วน',
                description: 'ขอยกตัวอย่าง John และ Sarah อยู่ในองค์กรที่แตกต่างกันและมีบทบาทแตกต่างกันภายใต้บริบทองค์กรต่างๆ วางเมาส์เหนือโมดูลแต่ละอันแล้วดูผลลัพธ์',
            },
        },
        organization_permissions: 'สิทธิ์ขององค์กร',
        organization_roles: 'บทบาทขององค์กร',
        admin: 'ผู้ดูแล',
        member: 'สมาชิก',
        guest: 'แขก',
        role_description: 'บทบาท "{{role}}" ใช้แม่แบบองค์กรเดียวกันในองค์กรต่างๆ',
        john: 'John',
        john_tip: 'John อยู่ในสององค์กรด้วยอีเมล "john@email.com" เป็นไอดีเดียว เขาเป็นผู้ดูแลขององค์กร A และเป็นแขกขององค์กร B',
        sarah: 'Sarah',
        sarah_tip: 'Sarah อยู่ในหนึ่งองค์กรด้วยอีเมล "sarah@email.com" เป็นไอดีเดียว เธอเป็นผู้ดูแลขององค์กร B',
    },
};
export default Object.freeze(organizations);
